export function setWhiteLabel(state, val) {
  state.config.whiteLabel = val;
}

export function setConfig(state, val) {
  state.config = val;
}
